import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  faEye
} from "@fortawesome/free-solid-svg-icons";
import JSONPretty from "react-json-pretty";
import { withAppHOC } from "../../hoc";
import PageHeading from "../../components/PageHeader/PageHeader";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import NoData from "../../components/NoData/NoData";
import StatusHighliter from "../../components/StatusHighliter/StatusHighliter";
import {
  MessageBox,
  CustomButton,
  Label,
  Fieldset,
  TextInput,
  Button,
  Form,
  ResetButton,
  Dropdown,
  CustomConfirmButton,
  FormContainer,
  UpdateButton,
  NumberInput,
} from "../../components/FormElements";
import { TableBuilder } from "../../components/TableElements";
import Modal from "../../components/Modal";
import {
  StyledFiltersContainer,
  StyledModalContainer,
  StyledBodyContainer,
  StyledHeading,
  StyledContent,
  StyledApiCallLogsContainer,
  StyledSpan,
} from "../../components/Styled";
import Pagination from "../../components/Pagination/Pagination";
import API from "../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../constants";
import {
  getSearchParams,
  formatCurrency,
  formatCurrency4Decimal,
  shouldRedirect,
  redirectToPageOne,
} from "../../utils";
import FiltersButton from "../../components/FiltersButton/FiltersButton";
import Accordination from "../../components/Accordination/Accordination";
import { Grid, GridItem } from "../../components/Grid";
import moment from "moment";
import OverlayLoader from "../../components/OverlayLoader/OverlayLoader";

const IssueRechargeTransactionsList = (props) => {
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams("pageNumber") || 1,
    recordsPerPage: getSearchParams("recordsPerPage") || 100,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [users, setUsers] = useState([]);
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [usersId, setusersId] = useState("");
  const [transactionsId, setTransactionsId] = useState("");
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");

  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetFilters = () => {
    setFromDate("");
    setToDate("");
    setusersId("");
    setTransactionsId("");
    readData();
  };


  const readUsers = () => {
    API.get("/accounts-management/users").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setUsers(data);
      }
    });
  };

  const readData = useCallback(
    (
      fromDate = "",
      toDate = "",
      usersId = "",
      transactionsId = "",
    ) => {
      setIsLoading(true);
      setResponseStatus("");
      setResponseMessage("");
      API.get(
        `/transactions/issue-transactions?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fromDate=${fromDate}&toDate=${toDate}&usersId=${usersId}&transactionsId=${transactionsId}`
      )
        .then((response) => {
          const { status, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.SUCCESS) {
              setTotalRecords(pageInfo.totalRecords);
            }
            setTransactions(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILED);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const readLogs = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/transactions/logs/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setModalData(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const readHits = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/transactions/hits/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setModalData(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleModal = (id, modalType) => {
    setModalType(modalType);
    setShowModal(true);
    setModalData([]);
    if (modalType === "LOGS") {
      readLogs(id);
    }
    if (modalType === "HITS") {
      readHits(id);
    }
  };



  const reloadData = () => {
    readData(
      fromDate,
      toDate,
      usersId,
      transactionsId,
    );
  };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    readUsers();
  }, []);

  useEffect(() => {
    if (!isFiltering) {
      readData(
        fromDate,
        toDate,
        usersId,
        transactionsId,
      );
    }
  }, [paginationData, readData]);

  const { accountsPermissions } = props;
  const canTrack =
    accountsPermissions.includes(PERMISSION_TYPES.TRACK) || false;

  const userOptions = [{ title: "-- SELECT USER --", value: "" }];
  if (users && users.length > 0) {
    users.forEach(({ id, firmName, mobileNumber }) =>
      userOptions.push({
        title: firmName,
        value: id,
        subTitle: mobileNumber,
      })
    );
  }


  return (
    <>
      <PageHeading
        {...props}
        reloadData={reloadData}
      />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? "show" : ""}>
        <Form method="POST" action="#" onSubmit={filterData}>
          <Fieldset>
            <Label>User</Label>
            <Dropdown
              placeholder="Buyer"
              value={usersId}
              onChange={setusersId}
              options={userOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Transactions Id</Label>
            <TextInput
              value={transactionsId}
              onChange={setTransactionsId}
              placeholder="Transactions Id"
              maxLength={1000}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>From Date</Label>
            <TextInput
              type="date"
              value={fromDate}
              onChange={setFromDate}
              placeholder="From Date"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>To Date</Label>
            <TextInput
              type="date"
              value={toDate}
              onChange={setToDate}
              placeholder="To Date"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading}
              type="button"
              onClick={resetFilters}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <LoadingSpinner
        isLoading={
          !showModal &&
          responseStatus === "" &&
          transactions?.length === 0 &&
          isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILED &&
          !isLoading &&
          transactions?.length === 0
        }
        message={`No transactions found`}
      />
      {!showModal && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {transactions?.length > 0 && (
        <>
          <TableBuilder
            isLoading={!showModal && transactions?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: "",
                dataSelector: "transactionsId",
                sticky: true,
                canSort: false,
                width: "100px",
                CellRenderer: (value, item) => (
                  <>
                    {canTrack && (
                      <>
                        <CustomButton
                          icon={faEye}
                          onClick={() => toggleModal(value, "LOGS")}
                          style={{ color: "orange" }}
                        />
                      </>
                    )}
                  </>
                ),
              },
              {
                title: "Date Time",
                dataSelector: "createdOn",
                dataType: "string",
              },
              {
                title: "Transaction Id",
                dataSelector: "transactionsId",
                dataType: "string",
              },
              {
                title: "User",
                dataSelector: "firmName",
                dataType: "string",
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    <StyledSpan>{item.buyersMobileNumber}</StyledSpan>
                  </>
                ),
              },
              {
                title: "Profile",
                dataSelector: "profileType",
                dataType: "string",
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    <StyledSpan>{item.buyersMobileNumber}</StyledSpan>
                  </>
                ),
              },
              {
                title: "Debit",
                dataSelector: "Debit",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "Credit",
                dataSelector: "Credit",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "Difference",
                dataSelector: "difference",
                dataType: "number",
                CellRenderer: (value) => value || "N/A",
              },
            ]}
            tableData={transactions}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              resetResponseData();
              setShowModal(false);
              setModalType("");
              setModalData([]);
            }}
            hideCloseButton
          >
            <StyledModalContainer width={`1200px`}>
              {
                (
                  <>
                    <h3>
                      {modalType === "HITS"
                        ? "Transaction Hits"
                        : "API Call Logs"}
                    </h3>
                    <StyledApiCallLogsContainer>
                      <LoadingSpinner
                        isLoading={
                          responseStatus === "" &&
                          modalData?.length === 0 &&
                          isLoading
                        }
                      />
                      <NoData
                        status={
                          responseStatus !== API_RESPONSE_TYPES.FAILED &&
                          !isLoading &&
                          modalData?.length === 0
                        }
                        message={
                          modalType === "HITS"
                            ? `No transaction hits found`
                            : `No api logs found`
                        }
                      />
                      <MessageBox
                        status={responseStatus}
                        message={responseMessage}
                      />

                      {modalType === "HITS" ? (
                        <>
                          <TableBuilder
                            isLoading={
                              showModal && modalData?.length !== 0 && isLoading
                            }
                            tableHeadings={[
                              {
                                title: "Hits Id",
                                dataSelector: "id",
                                dataType: "string",
                              },
                              {
                                title: "Transaction Id",
                                dataSelector: "transactionsId",
                                dataType: "string",
                              },
                              {
                                title: "Transaction Time",
                                dataSelector: "createdOn",
                                dataType: "string",
                              },
                              {
                                title: "API Name",
                                dataSelector: "apiName",
                                dataType: "string",
                              },
                              {
                                title: "Transaction Type",
                                dataSelector: "transactionsType",
                                dataType: "string",
                              },
                              {
                                title: "GST Type",
                                dataSelector: "gstType",
                                dataType: "string",
                                CellRenderer: (value) => (value ? value : "N/A"),
                              },
                              {
                                title: "Balance Required",
                                dataSelector: "balanceRequired",
                                dataType: "string",
                              },
                              {
                                title: "Processed Margin",
                                dataSelector: "processedMargin",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Margin",
                                dataSelector: "sellersMargin",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Ref Id",
                                dataSelector: "sellersApiTransactionsId",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Status",
                                dataSelector: "sellersStatus",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Operators Id",
                                dataSelector: "sellersOperatorsId",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Operator Code",
                                dataSelector: "sellersOperatorCode",
                                dataType: "string",
                              },
                              {
                                title: "Sellers Message",
                                dataSelector: "sellersMessage",
                                dataType: "string",
                              },
                              {
                                title: "Request On",
                                dataSelector: "requestOn",
                                dataType: "string",
                              },
                              {
                                title: "Response On",
                                dataSelector: "responseOn",
                                dataType: "string",
                              },
                            ]}
                            tableData={modalData}
                          />
                        </>
                      ) : (
                        <>
                          {modalData?.length > 0 &&
                            modalData.map(
                              (
                                {
                                  requestType,
                                  request,
                                  requestOn,
                                  requestBody,
                                  response,
                                  responseOn,
                                },
                                index
                              ) => (
                                <Accordination
                                  key={index}
                                  header={`${requestType}`}
                                  autoExpanded={true}
                                >
                                  <Grid
                                    columns={"calc(50% - 10px) calc(50% - 10px)"}
                                  >
                                    <GridItem>
                                      <StyledBodyContainer>
                                        <StyledHeading>
                                          API Request{" "}
                                          {requestOn && `( ${requestOn} )`}
                                        </StyledHeading>
                                        <StyledContent>{request}</StyledContent>
                                      </StyledBodyContainer>
                                      {requestBody && (
                                        <StyledBodyContainer>
                                          <StyledHeading>
                                            API Request Body
                                          </StyledHeading>
                                          <StyledContent>
                                            {requestBody}
                                          </StyledContent>
                                        </StyledBodyContainer>
                                      )}
                                    </GridItem>
                                    <GridItem>
                                      <StyledBodyContainer>
                                        <StyledHeading>
                                          API Response{" "}
                                          {responseOn && `( ${responseOn} )`}
                                        </StyledHeading>
                                        <StyledContent>
                                          <JSONPretty
                                            id="json-pretty"
                                            data={response}
                                          ></JSONPretty>
                                        </StyledContent>
                                      </StyledBodyContainer>
                                    </GridItem>
                                  </Grid>
                                </Accordination>
                              )
                            )}
                        </>
                      )}
                    </StyledApiCallLogsContainer>
                  </>
                )}
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(IssueRechargeTransactionsList);
